import * as React from "react"
import {keyframes} from "@emotion/react";
import {Box, Typography} from "@mui/material";
import {TooltipSeeker} from "@ui-seeker/core";
import {formatPercentage} from "@ui-seeker/utils";

import PercentageChartNewElementTooltip from "./Tooltip";
import PercentageChartNewElementDiffBlock from "./DiffBlock";
import PercentageChartNewElementLinkWrapper from "./LinkWrapper";


const animationColumn = keyframes({
	from: {
		transform: "translateY(100%)",
		opacity: 0
	}, to: {
		transform: "translateY(0)",
		opacity: 1
	}
})

const animationRow = keyframes({
	from: {
		transform: "translateX(-100%)",
		opacity: 0
	}, to: {
		transform: "translateX(0)",
		opacity: 1
	}
})

export default function PercentageChartNewElement({ label, width, diff, color, fontColor, link=null, remainingData=[], column=false }) {

	return <TooltipSeeker title={<PercentageChartNewElementTooltip
		label={label}
		width={width}
		diff={diff}
		remainingData={remainingData}
	/>}>
		<Box
			height={column ? `${width}%` : 1}
			backgroundColor={color}
			width={!column ? `${width}%` : 1}
			sx={ link ? {
				animation: `${column ? animationColumn : animationRow} 1s ease-in-out`,
				"&:hover": { transform: "scale(1.1)"}
			} : {}}
		>
			<PercentageChartNewElementLinkWrapper
				link={link}
				target="_blank"
				display="flex"
				flexDirection="column"
				justifyContent="flex-start"
				alignItems="center"
				width={1}
				height={1}
			>
				<Typography variant="button" display={width >= 2.6 ? 'block' : 'none'} color={fontColor}>
					{formatPercentage(width, { decimals: 1 })}
				</Typography>
				{ width >= 10 && (diff ?? null) !== null && <Box width={1} textAlign="right" mt={-0.8} mr={0.6} p={0.3}>
					<PercentageChartNewElementDiffBlock diff={diff} />
				</Box> }
			</PercentageChartNewElementLinkWrapper>
		</Box>
	</TooltipSeeker>
}